export default "__VITE_ASSET__Dq0i3IpA__"